module.exports = __webpack_public_path__ + "img/dk.7babc923.svg";